<div class="loading-screen-wrapper" *ngIf="loading">
  <div class="loading-screen-icon">
    <div class="dashboard-loader"></div>
  </div>
</div>
